export default __webpack_public_path__ + "static/media/OpenPotion.00a24de6.mp3";